<div *ngIf="error" class="d-flex align-items-center justify-content-center w-100 h-100">
  <i class="fa fa-exclamation-triangle text-danger"></i>
</div>
<div *ngIf="!loaded && !error" class="d-flex align-items-center justify-content-center w-100 h-100">
  <div class="spinner-grow spinner-grow-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<img [hidden]="!loaded || error" [src]="url" alt="" class="w-100 h-100" #image crossorigin="anonymous"/>
